import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import { roundUp } from '../functions/functions';
import FlatListItem from "./FlatListItem";
import PlaceSearch from './PlaceSearch';
import { FiSearch } from 'react-icons/fi';

import { db, auth } from '../functions/firebaseFunctions'

  
export default function RegvenuesTab() {
    const [actVs, setActVs] = useState(null);
    
    useEffect(() => {
        console.log('test')
        db.collection('venue')
          .get()
          .then((doc) => {
            if (!doc.empty) {
              const vensArr = [];
              let counter = 0;
              let max = doc.docs.length;
              doc.docs.forEach(vens => {
                vensArr.push({ name: vens.data().name, id: vens.data().venueId, docid: vens.data().docid });
                counter++;
                if (counter === max) {
                  setActVs(vensArr);
                }
              }); 
            }
          }).catch(err => console.log('err', err));
    }, []);

    return(
        <>
            <div className='browsePannel' style={{gap: '0px 10px'}}>
              {actVs ?
                actVs.map(actV => 
                <Link to={`/venue/${actV.id}&${actV.docid}`}>
                  <FlatListItem key={actV.docid} item={actV} type="venue"
                  onClick={() => console.log(actV)} />
                </Link> )
                : <p style={{ color: 'white', textAlign: 'center' }}>No Venues Posted</p>}
            </div>
        </>
    )
}